export default "__VITE_ASSET__ByZnlfe$__"